import _ from "lodash";
export default (state: tcpinpoint.Portfolio[] = [], action: any) => {
	switch (action.type) {
		case "GET_PORTFOLIO_SUCCESS":
			return _.unionBy([action.resource as tcpinpoint.Portfolio], state, "id");
		case "GET_PORTFOLIOS_SUCCESS":
			return _.unionBy(action.resource as tcpinpoint.Portfolio[], state, "id");
		case "DELETE_PORTFOLIO_SUCCESS":
			return _.filter(state, resource => resource.id !== action.resource.id);
		case "CLEAR_SESSION":
			return [];
		default:
			return state;
	}
};
